import axios from "axios";
const axiosAPI = axios.create();

// Request interceptor for API calls
axiosAPI.interceptors.request.use(
  async (config) => {
    config.headers = {
      // Authorization: `Bearer ${jwtToken}`,
      "TOKEN-SSO":
        JSON.parse(localStorage.getItem("authenticatedUser"))?.token ?? null,
      Accept: "application/json",
      "Content-Type": "application/json",
    };
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// Response interceptor for API calls
axiosAPI.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    if (!!error.response) {
      if (error.response.status === 401 && !originalRequest._retry) {
        await localStorage.removeItem("authenticatedUser");
        
        window.location.href = "/";
        // window.location.href = error.response.data.redirect

        
        // originalRequest._retry = true;
        // axios
        //   .post(
        //     API + "auth/sso/get-new-token",
        //     {},
        //     {
        //       headers: { Authorization: `Bearer ${jwt}` },
        //     }
        //   )
        //   .then((res) => {
        //     jwtToken = res.data.data.value;
        //     localStorage.setItem("jwtToken", res.data.data.value);

        //     return axiosAPI(originalRequest);
        //   })
        //   .catch((err) => {
        //     window.location = "/";
        //   });
        // const access_token = await refreshAccessToken();
        // axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token;
        // return axiosAPI(originalRequest);
      } else if (error.response.status === 405) {
        if (error.response.data !== undefined)
          localStorage.setItem("jwtToken", error.response.data.value);
        return axiosAPI(originalRequest);
      }

      if (error.response.data.message === "The token has been blacklisted") {
        localStorage.clear();

        window.location = "/";
      }
    }
    return Promise.reject(error);
  }
);

export default axiosAPI;
